const sa = {
    common: {
        history: "النسخة التاريخية"
    }
};
export default sa;



// WEBPACK FOOTER //
// ./src/i18n/langs/sa.js